module.exports = __webpack_public_path__ + "static/media/pic.8dea102f.png";